/*
 * Category carousel arrows.
 *
 * Its own file, and not a {% javascript %} block on the section: Horizon
 * never emits a section-scripts bundle, so that block is written to the
 * theme but never served to the storefront. It is also kept out of luxe.js,
 * whose CDN object went on serving a stale copy under a fresh ?v= hash.
 */
(() => {
  function wire(root) {
    if (root.dataset.luxeCatsBound) return;
    const track = root.querySelector('[data-luxe-cats-track]');
    const prev = root.querySelector('[data-luxe-cats-prev]');
    const next = root.querySelector('[data-luxe-cats-next]');
    if (!track || !prev || !next) return;
    root.dataset.luxeCatsBound = 'true';

    const step = () => {
      const card = track.querySelector('.luxe-cats__item');
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const sync = () => {
      // Nothing to scroll: hide both arrows rather than show dead controls.
      const overflows = track.scrollWidth - track.clientWidth > 4;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      prev.hidden = !overflows || atStart;
      next.hidden = !overflows || atEnd;
    };

    // Deliberately an instant jump. Both scrollBy({behavior:'smooth'}) and CSS
    // scroll-behavior need animation frames, and a page that never paints —
    // a background tab, a throttled webview — then scrolls nowhere at all.
    // Correctness must not depend on frames; scroll-snap already makes the
    // move read as a step rather than a jolt.
    const glide = (delta) => {
      const max = track.scrollWidth - track.clientWidth;
      track.scrollLeft = Math.max(0, Math.min(max, track.scrollLeft + delta));
      sync();
    };

    prev.addEventListener('click', () => glide(-step()));
    next.addEventListener('click', () => glide(step()));
    track.addEventListener('scroll', sync, { passive: true });

    // Card widths are fixed, but a late web font or image can still shift the
    // track; re-check on resize and once everything has loaded.
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    sync();
  }

  const boot = () => document.querySelectorAll('[data-luxe-cats]').forEach(wire);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
